export default __webpack_public_path__ + "static/media/signal_10.3cf04345.mp3";